import { motion } from 'framer-motion';
import { FC } from 'react';

export const AnimatedScale: FC<{
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    k?: string;
}> = ({ children, className, style, k }) => (
    <motion.div
        key={k}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0 }}
        className={className}
        style={style}
    >
        {children}
    </motion.div>
);
